import jwtDecode from 'jwt-decode'
import { tokenService } from './Token.service'

type IdTokenClaims = {
  'custom:clientId'?: string
}

const CLIENT_ID_CLAIM_KEY = 'custom:clientId'

function getIdToken(idTokenFromStore?: string): string | undefined {
  if (idTokenFromStore) {
    return idTokenFromStore
  }

  return tokenService.getIdTokenEntry()
}

function decodeToken(idToken?: string): IdTokenClaims | undefined {
  if (!idToken) {
    return
  }

  try {
    return jwtDecode<IdTokenClaims>(idToken)
  } catch (error) {
    return
  }
}

function hasClientClaim(idTokenFromStore?: string): boolean {
  const idToken = getIdToken(idTokenFromStore)
  const decodedToken = decodeToken(idToken)
  const clientId = decodedToken?.[CLIENT_ID_CLAIM_KEY]
  return clientId !== null && clientId !== undefined && clientId !== ''
}

function shouldHideMenuOptions(idTokenFromStore?: string): boolean {
  return hasClientClaim(idTokenFromStore)
}

function canAccessDirectoryRoutes(idTokenFromStore?: string): boolean {
  return !shouldHideMenuOptions(idTokenFromStore)
}

export const menuVisibilityService = {
  shouldHideMenuOptions,
  canAccessDirectoryRoutes,
}
